import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { forceUpdateNow } from "@/serviceWorkerRegistration";

// Shows a persistent, non-intrusive prompt when a newer build has been deployed,
// so staff update on their own click instead of being reloaded mid-task or
// having to hard-refresh (Ctrl+Shift+R). The service worker registration
// dispatches "emedbay:update-available" (and sets window.__emedbayUpdatePending)
// when it detects a new build on load / focus / tab visibility.
export default function UpdateNotifier() {
  const shownRef = useRef(false);

  useEffect(() => {
    const show = () => {
      if (shownRef.current) return;
      shownRef.current = true;
      toast("A new version is available", {
        id: "app-update",
        description: "Refresh to load the latest updates.",
        duration: Infinity,
        action: {
          label: "Refresh now",
          onClick: () => forceUpdateNow(),
        },
      });
    };

    // The event may have fired before this mounted (e.g. on first load), so
    // check the pending flag too.
    if (typeof window !== "undefined" && window.__emedbayUpdatePending) show();

    window.addEventListener("emedbay:update-available", show);
    return () => window.removeEventListener("emedbay:update-available", show);
  }, []);

  return null;
}
